/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';

class ShortenerDetailDomain extends React.Component {
    render() {
        let panelContent = null,
            domainContent = null,
            domain = (this.props.data !== undefined && this.props.data.domain) ? this.props.data.domain : '',
            redirectDomain = (this.props.data !== undefined && this.props.data.redirectDomain) ? this.props.data.redirectDomain : '';

        if (this.props.state === 'edit') {
            domainContent = (
                <div className="domain-display">{this.props.data.domain}</div>
            );
        } else {
            domainContent = (
                <div>
                    <ErrorModule
                        app={this.props.app}
                        keys={['DOMAIN_UPDATE', 'DOMAIN_CREATE']}
                        render={(state) => {
                            return (
                                <FieldError field="domain" errors={state.errors}/>
                            );
                        }}/>
                    <UncontrolledTextInput className="text-input med" defaultValue={domain} onChange={this.props.update} data-field="data.domain"/>
                </div>
            );
        }

        panelContent = (
            <div>
                <fieldset>
                    <legend>Custom Short Domain <HelpButton which="customDomain"/><span className="required">*</span></legend>
                    {domainContent}
                </fieldset>
                <fieldset>
                    <legend>Redirect the root of your custom domain to</legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['DOMAIN_UPDATE', 'DOMAIN_CREATE']}
                        render={(state) => {
                            return (
                                <FieldError field="redirectDomain" errors={state.errors}/>
                            );
                        }}/>
                    <UncontrolledTextInput className="text-input med" defaultValue={redirectDomain} onChange={this.props.update} data-field="data.redirectDomain"/>
                </fieldset>
                <fieldset>
                    <legend>Default</legend>
                    <Toggle
                        active={this.props.convertValueForToggle(this.props.data.default)}
                        callback={this.props.updateSystemDefault}
                        linkedField="data.default"
                        noLabel={true}
                        toggleClass="inline" />
                    <span className="form-inline-label light">Use this as the default when sharing manually or setting up new automated sharing.</span>
                </fieldset>
                {this.props.getApplyButtons()}
                {this.props.getSaveButtons()}
            </div>
        );

        return panelContent;
    }

};

export default ShortenerDetailDomain;
